"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var Person_1 = __importDefault(require("@mui/icons-material/Person"));
var Settings_1 = __importDefault(require("@mui/icons-material/Settings"));
var AccessTime_1 = __importDefault(require("@mui/icons-material/AccessTime"));
var trans_1 = __importDefault(require("@/plugins/trans"));
var UserContext_1 = __importDefault(require("../context/UserContext"));
var Link_1 = __importDefault(require("../components/Link"));
var AccountMenu = function (_a) {
    var anchorEl = _a.anchorEl, open = _a.open, handleClose = _a.handleClose;
    var _b = (0, react_1.useContext)(UserContext_1.default), isAdmin = _b.isAdmin, userImageSrc = _b.userImageSrc;
    return ((0, jsx_runtime_1.jsxs)(material_1.Menu, __assign({ anchorEl: anchorEl, id: "account-menu", open: open, onClose: handleClose, onClick: handleClose, PaperProps: {
            elevation: 0,
            sx: {
                overflow: 'visible',
                filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                mt: 1.5,
                '& .MuiAvatar-root': {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                },
                '&:before': {
                    content: '""',
                    display: 'block',
                    position: 'absolute',
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: 'background.paper',
                    transform: 'translateY(-50%) rotate(45deg)',
                    zIndex: 0,
                },
            },
        }, transformOrigin: { horizontal: 'right', vertical: 'top' }, anchorOrigin: { horizontal: 'right', vertical: 'bottom' } }, { children: [(0, jsx_runtime_1.jsxs)(material_1.MenuItem, __assign({ component: Link_1.default, asAnchor: true, to: "/account" }, { children: [userImageSrc ? ((0, jsx_runtime_1.jsx)(material_1.Avatar, { src: userImageSrc, sx: { width: 30, height: 30, objectFit: 'cover', borderRadius: '50%' } })) : ((0, jsx_runtime_1.jsx)(Person_1.default, { fontSize: "large" })), trans_1.default.get('entities.profile')] })), (0, jsx_runtime_1.jsx)(material_1.Divider, {}), isAdmin && ((0, jsx_runtime_1.jsxs)(material_1.MenuItem, __assign({ component: Link_1.default, asAnchor: true, to: "/admin/dashboard" }, { children: [(0, jsx_runtime_1.jsx)(material_1.ListItemIcon, { children: (0, jsx_runtime_1.jsx)(Settings_1.default, { fontSize: "small" }) }), trans_1.default.get('navs.frontend.management')] }))), (0, jsx_runtime_1.jsxs)(material_1.MenuItem, __assign({ component: Link_1.default, asAnchor: true, to: "/logout" }, { children: [(0, jsx_runtime_1.jsx)(material_1.ListItemIcon, { children: (0, jsx_runtime_1.jsx)(AccessTime_1.default, { fontSize: "small" }) }), "Logout"] }))] })));
};
exports.default = AccountMenu;
